export default __webpack_public_path__ + "static/media/gtbit.7ed8784d.png";